import React, { useEffect, useState } from 'react';
import { isServerSide } from '~/src/helpers/ssr';
import { StyledPlank } from '~/src/layout/login/styled';
import { intervalToHumanReadable } from '~/src/helpers/formatter';

/**
 * @param {Date} expires
 * @param clearInvalidLogin
 * @return {JSX.Element}
 * @constructor
 */
export function RenderBlockedMessage({ expires, clearInvalidLogin }) {
    useEffect(() => {
        if (isServerSide()) {
            return;
        }

        if (expires == null) {
            return;
        }
        //          отодвигаем срабатывание - небольшая задержка работы экшена
        const diff = (expires - new Date()) - 1500;
        if (diff <= 0) {
            clearInvalidLogin();
            return;
        }

        const timer = setTimeout(() => {
            clearInvalidLogin();
        }, diff);
        return function() {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [expires]);
    const [diff, setDiff] = useState(expires - new Date());
    useEffect(() => {
        const interval = setInterval(() => {
            setDiff(expires - new Date());
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return <StyledPlank>
        Доступ к личному кабинету заблокирован на {intervalToHumanReadable(diff)}.
    </StyledPlank>;
}
